export enum AnnouncementPersistenceTypes {
  ONCE = 'once',
  STATIC = 'static',
  SESSION = 'session',
}

export enum AnnouncementCookieTypes {
  ONCE = 'AAP-Announcements-once',
  SESSION = 'AAP-Announcements-session',
}
